import * as React from "react";
import { IconProps } from "./IconProps";

export const IconStorage = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.33301 2.49984C3.33301 2.0396 3.7061 1.6665 4.16634 1.6665H15.833C16.2932 1.6665 16.6663 2.0396 16.6663 2.49984V17.4998C16.6663 17.9601 16.2932 18.3332 15.833 18.3332H4.16634C3.7061 18.3332 3.33301 17.9601 3.33301 17.4998V2.49984ZM4.99967 13.3332V16.6665H14.9997V13.3332H4.99967ZM14.9997 11.6665H4.99967V3.33317H14.9997V11.6665Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.333 15.8332C12.8728 15.8332 12.4997 15.4601 12.4997 14.9998C12.4997 14.5396 12.8728 14.1665 13.333 14.1665C13.7932 14.1665 14.1663 14.5396 14.1663 14.9998C14.1663 15.4601 13.7932 15.8332 13.333 15.8332ZM10.833 15.8332C10.3728 15.8332 9.99967 15.4601 9.99967 14.9998C9.99967 14.5396 10.3728 14.1665 10.833 14.1665C11.2932 14.1665 11.6663 14.5396 11.6663 14.9998C11.6663 15.4601 11.2932 15.8332 10.833 15.8332Z"
          fill={color}
        />
      </svg>
    );
  },
);
